/**
 * Maps raw Eurobasket position strings (PG, SG, SF, PF, C, G, F, G/F, F/C, ...)
 * to internal app position keys (pointGuard, shootingGuard, smallForward,
 * powerForward, center).
 *
 * Mirrors back/utils/eurobasketData.js:EUROBASKET_POS_TO_APP_KEYS so filter
 * decisions are consistent between client and server.
 *
 * Hybrid/generic Eurobasket positions map to multiple app keys — a "G/F"
 * player matches both `shootingGuard` and `smallForward` filters.
 */
const EUROBASKET_POS_TO_APP_KEYS = {
  PG:  ['pointGuard'],
  SG:  ['shootingGuard'],
  G:   ['pointGuard', 'shootingGuard'],
  SF:  ['smallForward'],
  PF:  ['powerForward'],
  F:   ['smallForward', 'powerForward'],
  C:   ['center'],
  'G/F': ['shootingGuard', 'smallForward'],
  'F/G': ['shootingGuard', 'smallForward'],
  'F/C': ['powerForward', 'center'],
  'C/F': ['powerForward', 'center'],
  'D/C': ['powerForward', 'center'],
  'P/C': ['powerForward', 'center'],
};

export const APP_POSITION_KEYS = [
  'pointGuard', 'shootingGuard', 'smallForward', 'powerForward', 'center',
];

/**
 * Translate a raw Eurobasket position string ("PG", "G/F", ...) into a
 * localised label using the app's position translations. Hybrids show as
 * "Escolta/Alero" (joined with /). Falls back to the raw value if unknown.
 */
export const translateEurobasketPos = (rawPos, t) => {
  if (!rawPos) return null;
  const appKeys = EUROBASKET_POS_TO_APP_KEYS[rawPos];
  if (!appKeys || appKeys.length === 0) return rawPos;
  return appKeys.map(k => t(`positions.${k}`)).join('/');
};

/**
 * True if the stored value is in the legacy bucket format (G, G/F, F, F/C, C).
 * Used to discard stale sessionStorage entries when migrating to app keys.
 */
export const isLegacyPositionFilter = (value) =>
  value !== null && value !== undefined &&
  ['G', 'G/F', 'F', 'F/C', 'C'].includes(value);
